"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyArray = void 0;
const is_array_1 = require("./is-array");
exports.isEmptyArray = (value) => is_array_1.isArray(value) && value.length <= 0;
//# sourceMappingURL=is-empty-array.js.map